import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { DialogService } from "primeng/dynamicdialog";
import { FacilityAddSchoolComponent } from "./facility-add-school/facility-add-school.component";

@Component({
	selector: "caass-siteadmin-facility-schools",
	templateUrl: "./siteadmin-facility-schools.component.html",
	styleUrls: ["./siteadmin-facility-schools.component.css"],
})
export class SiteadminFacilitySchoolsComponent implements OnInit {
	constructor(private dialogService: DialogService) {}

	ngOnInit(): void {
		if (this.SchoolsFromMain != undefined) {
			this.lstSchool = this.SchoolsFromMain;
		}
	}

	ngOnChanges() {
		if (this.SchoolsFromMain != undefined) {
			this.lstSchool = this.SchoolsFromMain;
		}
	}

	///////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////
	@Output() NextClick: EventEmitter<any> = new EventEmitter();

	@Input() EditMode: any = false;
	@Input() SchoolsFromMain: any;
	@Input() OriginalFromMain: any;

	lstSchool: any = [];
	SelectedSchools: any = [];

	pagerows: any = 10;
	pagefirst: any = 0;

	cols = [
		{ field: "SchoolNumber", header: "School Number" },
		{ field: "SchoolName", header: "School Name" },
	];

	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////
	onNext() {
		let myData: any = {
			lstSchool: this.lstSchool,
		};

		this.NextClick.emit({
			NextPage: 3,
			Data: myData,
		});
	}
	onRemove() {
		this.lstSchool = this.lstSchool.filter((school) => this.SelectedSchools.indexOf(school) == -1);
	}
	onAdd() {
		var ref = this.dialogService.open(FacilityAddSchoolComponent, {
			header: "Add Schools",
			width: "fit-content",
			data: {
				SelectedSchools: this.lstSchool,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response != 0) {
				this.lstSchool = response;
			}
		});
	}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Events
	///////////////////////////////////////////////////////
	onHandleFilter(val) {}
	onHandleSort(val) {}
	onRowSelect(val) {}
	onRowUnselect(val) {}
	///////////////////////////////////////////////////////

	///////////////////////////////////////////////////////
	// Helpers
	///////////////////////////////////////////////////////

	GetBackground(school, i) {
		// console.log("Get Background");
		// console.log("School");
		// console.log(school);
		// console.log("I");
		// console.log(i);

		// console.log("Original Schools");
		// console.log(this.OriginalFromMain);

		//
		// Add mode
		//
		if (this.EditMode != true) {
			// console.log("Add mode");

			//
			// Normal striped table colors
			//

			if (i % 2 == 0) {
				return "#ffffff";
			} else {
				return "#fcfcfc";
			}
		}
		//
		// Edit mode no schools
		//
		else if (this.EditMode == true && this.OriginalFromMain == undefined) {
			// console.log("Edit mode no schools");

			//
			// Highlight new schools
			//
			return "#ffffb3";
		}

		//
		// Edit mode with schools already assigned
		//
		else {
			// console.log("Edit mode with existing schools");

			//
			// Check if school is from main load or if the user added it
			//
			var found = false;
			for (var z = 0; z < this.OriginalFromMain.length; z++) {
				var next = this.OriginalFromMain[z];

				if (school.SchoolID == next.SchoolID) {
					found = true;
				}
			}

			// console.log("Found in list");
			// console.log(found);

			//
			// Highlight new schools
			//
			if (!found) {
				return "#ffffb3";
			}
			//
			// Normal colors for existing schools
			//
			else {
				if (i % 2 == 0) {
					return "#ffffff";
				} else {
					return "#fcfcfc";
				}
			}
		}
	}

	///////////////////////////////////////////////////////
}
